import { createUseStyles } from 'react-jss'
import { backgroundGrey } from '../../../../../styles/const/colors'

const useStyles = createUseStyles({
  metric: {
    display: 'flex',
    justifyContent: 'space-between',
    padding: '4px 8px',
    fontSize: 12,

    '&:nth-child(2n)': {
      backgroundColor: backgroundGrey
    }
  }
})

export default useStyles
